module.exports = "<mdl-table-selectable mdl-shadow=\"2\"\n    [table-model]=\"tableModel\"\n    [table-model-selected]=\"selected\"\n    (table-model-selectionChanged)=\"selectionChanged()\">\n</mdl-table-selectable>\n<!--<p>{{selectionList | json}}</p>-->";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/model-components/insert-table.component.html
 ** module id = 216
 ** module chunks = 0
 **/